























































































import VueOptions from '@utils/VueOptions'
import UiList from '@superUI/List/List'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import Trigger from '@modules/ui/triggers/Trigger'
import ResourceList from '@modules/ui/List/ResourceList'
import LoadingIndicator from '@/components/LoadingIndicator'
import DebugOnly from '@/components/DebugOnly'

settings =
  name: 'OfferResourceList'

  vue:
    props: ['offers', 'bulkActionResultItems', 'actions', 'listItemActions', 'filtersOverriden', 'infiniteWrapper', 'options']
    components: {
      DebugOnly,
      UiList,
      Modal,
      RequestButton,
      Trigger,
      ResourceList,
      LoadingIndicator
    }

    data: ->
      activeFilter: false
      pageNumber: 1
      sortList: [
        { field: 'accepted_at', value: 'Accepted At' }
        { field: 'ctx.brand.name', value: 'Brand Name' }
        { field: 'expires_at', value: 'Expiration Date' }
        { field: 'aasm_state', value: 'Status' }
        { field: 'partnership_token', value: 'Partnership' }
      ]
      sortValue: ''
      
      filters: 
        scopes:
          published: null
          state: null
          horizon: null
          offers: null
        multi_filters: {}
        sort: [
          { field: 'accepted_at', order: 'desc' }
          { field: 'ctx.brand.name', order: 'asc' }
          { field: 'expires_at', order: 'desc' }
          { field: 'aasm_state', order: 'asc' }
          { field: 'partnership_token', order: 'asc' }
        ]

      selectedFilters: []
      selectedOffers: []

      selectedStatusList: []
      statusFilterBar:
        width: 0
        left: 0

    mounted: ->
      @filters = @filtersOverriden if @filtersOverriden?
      @loadFiltersFromURL()
      @initializeStatusFilterBar()

    computed:
      itemOptions: -> { componentResource: this }
      components: -> 
        { 'offer-resource-list-item' : () => import("./OfferResourceListItem") }
      offerTitlePrefix: ->
        return 'All' unless @$route.query.scope?
        return @$route.query.scope
      title: ->
        @options?.title || 'Offers'
      resourceKey: ->
        @options?.resourceKey || 'offers'
      availableSort: ->
        ctx = this
        availableList = @sortList.filter((sort) ->
          item = ctx.filters.sort.find((item) -> item.field == sort.field)
          !item
        )
        availableList
      selectedSortByName: -> @filters.sort.map (f) -> f.field

      organizer: -> @$store.member.organizer
      totalPendingPayoutInDollars: ->
        @ctxStats(@organizer).offer.total_pending_payout_in_dollars

    methods:
      sortFilterForName: (name) -> @filters.sort.find (f) -> f.field is name
      hiInfiniteScroll: (state) ->
        @actions.fetchResource(state, @resourceKey, @formatFiltersPayload(), { page: @pageNumber })
        @pageNumber += 1
      setFilters: (selectedFilters) ->
        @$refs.infiniteLoading.stateChanger.reset()
        @selectedFilters = selectedFilters if selectedFilters
        @pageNumber = 1
        @actions.fetchResource(null, @resourceKey, @formatFiltersPayload(), { page: @pageNumber })
        @pageNumber += 1

      formatFiltersPayload: ->
        payload = {...@filters}
        timeWindows = payload.time_windows

        payload.filters = payload.filters || {}
        for field, timeWindow of timeWindows
          payload.filters["#{field}_before"] = timeWindow.before if timeWindow.before
          payload.filters["#{field}_after"] = timeWindow.after if timeWindow.after
        if @$route.query.scope?
          scope = @$route.query.scope
          if scope is 'published'
            payload.scopes.published = 'published'
            payload.scopes.state = null
          else
            payload.scopes.published = null
            payload.scopes.state = scope
        else
          payload.scopes.published = null
          payload.scopes.state = null

        payload.multi_filters.any_state = @selectedStatusList
        delete payload.multi_filters.any_state if !@selectedStatusList.length
        payload
      hiSearchChange: (q = '') ->
        @filters.q = q
        @setFilters(@filters)
      hiClearFilter: ->
        cleared_filter_scope = @filters.scopes
        Object.keys(cleared_filter_scope).forEach((key) -> cleared_filter_scope[key] = null)
        @selectedFilters = []
        @setFilters(@filters)
      hiAddSort: (order) ->
        return false if !@sortValue.length
        @filters.sort.push({ field: @sortValue, order })
        @setFilters()
        @sortValue = ''
      hiRemoveSort: (sort) ->
        @filters.sort = @filters.sort.filter((item) -> item.field != sort.field)
        @setFilters(@filters)
      toggleSortOrder: (sort) -> 
        newOrder = if sort.order == 'asc' then 'desc' else 'asc'
        @filters.sort = @filters.sort.filter((item) ->
          item.order = newOrder if item.field == sort.field
          item
        )
      hiFlipOrder: (sort) ->
        @toggleSortOrder(sort)
        @setFilters(@filters)
      hiToggleAndUpdateSort: (sort) -> 
        @toggleSortOrder(sort)
        @pushSortOrder(sort)
        @setFilters(@filters)
      pushSortOrder: (sort) -> 
        otherFilters = @filters.sort.filter (f) -> f.field isnt sort.field
        sortFilters = []
        sortFilters.push(sort)
        if sort.field is 'aasm_state' # always sort by aasm_status AND date when sorting by status
          otherFilters = otherFilters.filter (f) -> f.field isnt 'expires_at'
          sortFilters.push @sortFilterForName('expires_at')
        sortFilters = sortFilters.concat(otherFilters)
        @filters.sort = sortFilters
      sortOrderArrowIcon: (order) ->
        if order == 'asc'
          return 'fa-arrow-up'
        return 'fa-arrow-down'
      sortOrderCaretIcon: (order) ->
        return 'fa-caret-up' if order is 'asc'
        return 'fa-caret-down'
      getFieldName: (field) -> @sortList.find((item) -> item.field == field).value

      initializeStatusFilterBar: ->
        @updateStatusFilterBar()

      updateStatusFilterBar: ->
        setTimeout(() =>
          element = document.querySelector('.primary-filter-item.active')
          position = { width: 0, left: 0 }
          position = { width: element.offsetWidth, left: element.offsetLeft } if element
          @statusFilterBar = position
        , 0)

      hiStatusFilterChange: (filterName) ->
        if 'all' is filterName
          @selectedStatusList = []
        else
          @selectedStatusList = [filterName]

        @updateStatusFilterBar()
        @updateFiltersOnURL()

      hiFilterChange: ->
        @updateFiltersOnURL()
        @setFilters()

      updateFiltersOnURL: ->
        status = @selectedStatusList.join(',')
        status = 'all' if status.length is 0
        @$router.push({ query: { status }})

      loadFiltersFromURL: ->
        queryStatus = if @$route.query.status is 'all' then '' else @$route.query.status || 'submitted'
        statusList = (status for status in queryStatus.split(',') when status isnt '')
        @selectedStatusList = statusList

    watch:
      $route: (newVal, oldVal) ->
        @setFilters(@filters)

export default VueOptions.vue settings
